import { render } from "./VLabel.vue?vue&type=template&id=8c958fcc"
import script from "./VLabel.vue?vue&type=script&lang=js"
export * from "./VLabel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__